































































import {
  Component, Mixins, Watch, Prop,
} from 'vue-property-decorator';
import Picked from '../components/Picked.vue';
import Slider from '../components/Slider.vue';
import PaletteBuilder from '../components/PaletteBuilder.vue';
import CopiedAlert from '../components/CopiedAlert.vue';
import SavedPalettes from '../components/SavedPalettes.vue';
import Converter from '../components/Converter.vue';


import ColorMixin from '../mixins/color';
import Clipboard from '../mixins/clipboard';
import { HSLColor } from '../types/color';

import FirebasePalette, { Palette } from '../mixins/firebase/palette';

const components = {
  Picked,
  Slider,
  PaletteBuilder,
  CopiedAlert,
  SavedPalettes,
  Converter,
};
@Component({ components })
export default class Picker extends Mixins(Clipboard, ColorMixin) {
  @Prop() default!: string;

  newPalette: Palette = {
    colors: [],
    key: null,
  };

  savedPalettes: Palette[] = [];

  mounted() {
    this.initiateStyleSheets();
    this.getPalettes();
  }

  setHue(hue: string) {
    this.picked.h = hue;
  }

  setSaturation(sat: string) {
    this.picked.s = sat;
  }

  setLightness(lig: string) {
    this.picked.l = lig;
  }

  addToPalette(color: HSLColor) {
    if (this.newPalette.colors.length < 6) {
      this.newPalette.colors.unshift(color);
    }
  }

  removeFromPalette(key: number) {
    this.newPalette.colors.splice(key, 1);
  }

  savePalette() {
    const { user } = this.$store.state;
    if (user && user.uid) {
      FirebasePalette.saveUserPalette(this.newPalette, user.uid);
    }
    this.savedPalettes.push({ ...this.newPalette });
    this.newPalette = { colors: [], key: null };
  }

  getPalettes() {
    const { user } = this.$store.state;

    if (!user) {
      return null;
    }

    return FirebasePalette.fetchUserPalettes(user.uid)
      .then((snapshot) => {
        snapshot.forEach((palette) => {
          this.savedPalettes.push(palette.val());
        });
      });
  }

  removePalette(key: number) {
    this.savedPalettes.splice(key, 1);
  }

  editPalette(palette: Palette) {
    this.newPalette = palette;
  }

  editColor(color: HSLColor) {
    this.picked = color;
  }

  addRule(value: string, gradient: string) {
    const styleSheet = document.getElementById(`${value}-setter`) as HTMLStyleElement;
    const sheet = styleSheet?.sheet as CSSStyleSheet;

    if (!sheet) { return; }

    while (sheet.cssRules.length) {
      sheet.deleteRule(0);
    }

    sheet.insertRule(`
      #${value}-range::-webkit-slider-thumb {
        background: hsl(${this.picked.h}, ${this.picked.s}%, ${this.picked.l}%)
      }`, sheet.cssRules.length);

    sheet.insertRule(`
      #${value}-range::-webkit-slider-runnable-track {
        background: linear-gradient( to right, ${gradient})
      }`, sheet.cssRules.length);
  }

  static createStyleSheet(value: string) {
    const styleSheet = document.createElement('style');
    styleSheet.setAttribute('id', `${value}-setter`);
    styleSheet.type = 'text/css';
    document.head.appendChild(styleSheet);
  }

  initiateStyleSheet(value: string, gradient: string) {
    Picker.createStyleSheet(value);
    this.addRule(
      value,
      gradient,
    );
  }

  initiateStyleSheets() {
    this.initiateStyleSheet('hue', this.hueGradient);
    this.initiateStyleSheet('saturation', this.saturationGradient);
    this.initiateStyleSheet('lightness', this.lightnessGradient);
  }

  @Watch('currentH')
  @Watch('currentL')
  @Watch('currentS')
  updateRules() {
    this.addRule(
      'hue',
      this.hueGradient,
    );
    this.addRule(
      'saturation',
      this.saturationGradient,
    );
    this.addRule(
      'lightness',
      this.lightnessGradient,
    );
  }

  get currentH(): string {
    return this.picked.h;
  }

  get currentS(): string {
    return this.picked.s;
  }


  get currentL(): string {
    return this.picked.l;
  }


  get hueGradient(): string {
    return `hsl(0, ${this.picked.s}%, ${this.picked.l}%),
  hsl(60, ${this.picked.s}%, ${this.picked.l}%),
  hsl(120, ${this.picked.s}%, ${this.picked.l}%),
  hsl(180, ${this.picked.s}%, ${this.picked.l}%),
  hsl(240, ${this.picked.s}%, ${this.picked.l}%),
  hsl(300, ${this.picked.s}%, ${this.picked.l}%),
  hsl(360, ${this.picked.s}%, ${this.picked.l}%)`;
  }


  get saturationGradient(): string {
    return `hsl(${this.picked.h}, 0%, ${this.picked.l}%),
  hsl(${this.picked.h}, 100%, ${this.picked.l}%)`;
  }


  get lightnessGradient(): string {
    return `hsl(${this.picked.h}, ${this.picked.s}%, 0%),
  hsl(${this.picked.h}, ${this.picked.s}%, 50%),
  hsl(${this.picked.h}, ${this.picked.s}%, 100%)`;
  }
}
